import { Box, Heading, Container } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import AiCategorySelect from "~/apps/cartario/pages/AiCategorySelect.tsx";
import {AiCatSelectOnClickPayload} from "~/utils/types.ts";

const GenerateImages = () => {
    const navigate = useNavigate();
    const handleModelClick = (payload: AiCatSelectOnClickPayload) => {
        const {publicId, category} = payload;

        if (!publicId || !category) {
            return;
        }
        navigate(`/c-panel/cartario/generate/${publicId}/${category}/`);
    };

    return (
        <Box bg="gray.800" color="primary.0" minH="100vh" p={4}>
            <Container maxW="container.xl">
                <Heading mb={8}>
                    AI Model Selection
                </Heading>

                <AiCategorySelect onClick={handleModelClick} />
            </Container>
        </Box>
    );
};

export default GenerateImages;